import { Action, createReducer, on } from '@ngrx/store';
import { WorkspaceItem, WorkspaceParentItem } from '@primatoo-ms-organization';
import * as WorkspaceActions from '../actions/workspace.actions';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

export const WORKSPACE_FEATURE_KEY = 'workspace';

export interface WorkspaceState {
  loading: boolean,
  currentWorkspaceItems: WorkspaceItem[],
  currentWorkspaceParents: WorkspaceParentItem[],
  workspaceColEnabled: ColumnWithLocalization[],
  currentError: unknown[]
}

export const initialState: WorkspaceState = {
  loading: false,
  currentWorkspaceItems: [],
  currentWorkspaceParents: [],
  workspaceColEnabled: [],
  currentError: []
};

export function workspaceReducer(state: WorkspaceState | undefined, action: Action) {

  const WorkspaceReducer = createReducer(
    initialState,

    on(WorkspaceActions.loadWorkspaceItems, (state) => ({
      ...state,
      loading: true,
      currentWorkspaceItems: []
    })),

    on(WorkspaceActions.loadWorkspaceItemsSuccess, (state, action: { items: WorkspaceItem[], parentItems: WorkspaceParentItem[] }) => ({
      ...state,
      loading: false,
      currentWorkspaceItems: action.items,
      currentWorkspaceParents: action.parentItems
    })),

    on(WorkspaceActions.loadWorkspaceItemsFailed, (state, action: { error }) => ({
      ...state,
      loading: false,
      currentWorkspaceItems: [],
      currentWorkspaceParents: [],
      currentError: [...state.currentError, action.error]
    })),


    on(WorkspaceActions.searchWorkspaceItems, (state) => ({
      ...state,
      loading: true,
      currentWorkspaceItems: [],
      currentWorkspaceParents: null
    })),

    on(WorkspaceActions.searchWorkspaceItemsSuccess, (state, action: { items: WorkspaceItem[] }) => ({
      ...state,
      loading: false,
      currentWorkspaceItems: action.items
    })),

    on(WorkspaceActions.searchWorkspaceItemsFailed, (state, action: { error }) => ({
      ...state,
      loading: false,
      currentWorkspaceItems: [],
      currentError: [...state.currentError, action.error]
    })),


    on(WorkspaceActions.getWorkspaceColEnabled, (state) => ({
      ...state,
      workspaceColEnabled: []
    })),

    on(WorkspaceActions.getWorkspaceColEnabledSuccess, (state, action: { colEnabled: ColumnWithLocalization[] }) => ({
      ...state,
      workspaceColEnabled: action.colEnabled
    })),

    on(WorkspaceActions.getWorkspaceColEnabledFailed, (state, action: { error }) => ({
      ...state,
      currentError: [...state.currentError, action.error]
    }))
  );

  return WorkspaceReducer(state, action);
}
